var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 32,
    viewBox: "0 0 72 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 11.52V31.93H20.29V11.52C20.29 6.98 16.64 3.46 11.84 3.46C7.04 3.46 3.39 6.98 3.39 11.52V31.93H0V11.52C0 11.14 0.0599976 10.88 0.0599976 11.26H0V0.0599995H3.39V3.26C4.35 1.98 7.93 0 11.84 0C18.3 0 23.74 5.25 23.74 11.52H23.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.49 15.965C71.49 24.605 64.26 31.835 55.62 31.835C46.98 31.835 39.75 24.605 39.75 15.965C39.75 7.325 46.98 0.0950012 55.62 0.0950012C64.26 0.0950012 71.49 7.325 71.49 15.965ZM68.1 15.965C68.1 8.985 62.6 3.485 55.62 3.485C48.64 3.485 43.14 8.985 43.14 15.965C43.14 22.945 48.64 28.445 55.62 28.445C62.6 28.445 68.1 22.945 68.1 15.965Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/NO.5aaff20790a9f80a0a7dc2a8589acc26.svg";
export { ForwardRef as ReactComponent };